<template>
    <form class="modal_content" @submit.prevent="store()">
        <p><strong>{{ $t('payment_method') }}: </strong>{{ paymentMethodName }}</p>
        <form @submit.prevent="store()" v-if="showForm">
            <div class="modal_content p-0 p-b-20">
                <div class="row">
                    <div class="col-sm-6 col-md-3" :class="{'has-error': errors['name']}">
                        <label class="control-label">{{ $t('name') }}</label>
                        <input type="text" class="form-control" v-model="record.name">
                        <span class="error" v-if="errors['name']">{{ errors['name'][0] }}</span>
                    </div>
                    <div class="col-sm-6 col-md-3" :class="{'has-error': errors['fee']}">
                        <label class="control-label">{{ $t('fee') }}</label>
                        <input type="text" class="form-control" v-model.lazy="record.fee" v-pml-mask="'percentage'">
                        <span class="error" v-if="errors['fee']">{{ errors['fee'][0] }}</span>
                    </div>
                    <div class="col-md-3 t_right m-t-23">
                        <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                        <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row" v-if="!showForm">
            <div class="col-md-6 p-b-10 m_md_bottom_15">
                <span class="btn btn-warning" v-pml-tooltip="$t('refresh')" @click.prevent="fetchRecord()"><i class="fa fa-refresh"></i></span>
                <router-link :to="{ name: 'payment-methods.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <span class="btn btn-default" @click.prevent="showForm = true"><i class="fa fa-plus-circle"></i> {{ $t('installment') }} </span>
            </div>
        </div>
        <div class="over_auto" v-pml-block="isLoading">
            <table class="table table-striped table-bordered m-0 table_border_out">
                <thead>
                    <tr>
                        <th>{{ $t('installment') }}</th>
                        <th class="t_center">{{ $t('fee') }}</th>
                        <th class="t_center w_100">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.fee }}</td>
                        <td class="t_center">
                            <span class="btn btn-xs btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="destroy(item.id)"><i class="fa fa-times"></i></span>
                        </td>
                    </tr>
                    <tr v-if="!list.length">
                        <td class="t_center" colspan="5"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getPaymentMethodsInstallments, storeInstallment, destroyInstallment } from 'services/payment-methods'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'PackageProducts',
        data () {
            return {
                showForm: false,
                isLoading: false,
                loadingProducts: false,
                isSaving: false,
                paymentMethod: {},
                record: {
                    name: null,
                    fee: null
                },
                errors: []
            }
        },
        mounted () {
            this.fetchRecord()
        },
        watch: {
            '$route' () {
                this.fetchRecord()
            }
        },
        computed: {
            ...mapGetters({
                paymentMethods: 'getPaymentMethods'
            }),
            paymentMethodName () {
                return this.paymentMethod.name || ''
            },
            list () {
                return this.paymentMethod.payment_installments || []
            }
        },
        methods: {
            ...mapActions([ 'paymentInstallmentsAmountUpdate' ]),
            fetchRecord () {
                this.isLoading = true

                getPaymentMethodsInstallments(this.$route.params.id)
                    .then(response => {
                        this.paymentMethod = response.data
                        this.paymentInstallmentsAmountUpdate(response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            cancel () {
                this.showForm = false
                this.record = {
                    name: null,
                    fee: null
                }
                this.errors = []
            },
            store () {
                this.isSaving = true
                this.record.fee = parseFloat(this.record.fee.replace(',', '.'))
                storeInstallment(this.$route.params.id, this.record)
                    .then(response => {
                        this.paymentInstallmentsAmountUpdate(response.data)
                        this.paymentMethod = response.data
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            destroy (id) {
                destroyInstallment(this.$route.params.id, id)
                    .then(response => {
                        this.paymentInstallmentsAmountUpdate(response.data)
                        this.paymentMethod = response.data
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/payment_methods/components/products/Main.vue